import { useCallback, useEffect, useRef } from 'react';

export const usePickedReviewsRef = (pickedReviews: string[]) => {
    const pickedReviewsRef = useRef<string[]>(pickedReviews);

    useEffect(() => {
        pickedReviewsRef.current = pickedReviews;
    }, [pickedReviews]);

    const getCurrentPickedReviews = useCallback(() => pickedReviewsRef.current, []);

    return {
        getCurrentPickedReviews,
    };
};
